module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_10-1576102f70199c7d4dcced0d6f47b93c.png";